import useAuth from '@/hooks/use-auth/use-auth';
import {useGlobalModal} from '@/organisms/Modal/ModalContext';
import {loadFollowedArtists, setFollowing} from '@/redux/actions/artistsFollowedActions';
import {STATUS_FAILED, STATUS_IDLE} from '@/redux/actionTypes';
import {selectFollowedState} from '@/redux/reducers/artistsFollowedReducer';
import LoginModal from '@/templates/Modals/Login/LoginModal';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {StyledFollowButton} from './styles';
import {Props} from './typings';

const FollowButton = ({
  artistId,
  artistSlug,
  artistName,
  followingCount,
  type,
  className,
}: Props) => {
  const auth = useAuth();
  const {openModal} = useGlobalModal();
  const dispatch = useDispatch();
  const {data: followedArtists, status: followedStatus} = useSelector(selectFollowedState);
  const isFollowing = followedArtists.includes(artistSlug);
  const [loading, setLoading] = useState(false);

  const toggleFollow = () => {
    if (!auth.isAuthenticated()) {
      openModal(<LoginModal />);
      return;
    }
    setLoading(true);

    const cleanupCallbacks = [
      () => {
        setLoading(false);
      },
    ];

    dispatch(setFollowing(artistId, artistSlug, !isFollowing, cleanupCallbacks));
  };

  const countFilter = (count) => {
    if (count < 1000) {
      return count;
    } else if (count % 1000 === 0) {
      return `${count / 1000}K`;
    } else {
      return `${Math.floor(count / 100) / 10}K+`;
    }
  };

  useEffect(() => {
    if (followedStatus === STATUS_IDLE || followedStatus === STATUS_FAILED)
      dispatch(loadFollowedArtists());
  }, []);

  return (
    <StyledFollowButton
      className={className}
      active={isFollowing}
      disabled={loading}
      onClick={toggleFollow}
      icon="heart"
      title={isFollowing ? `Unfollow ${artistName}` : `Follow ${artistName}`}
      size={type === 'small' ? 'small' : 'default'}
      $size={type ?? 'default'}
      children={
        type === 'text'
          ? `${isFollowing ? 'Following' : 'Follow'}${
              followingCount ? ` (${countFilter(followingCount)})` : ''
            }`
          : undefined
      }
    />
  );
};

export default FollowButton;
